import {
  COMPLETION_CARD_OPTION_KEYS,
  COMPLETION_CARD_OPTION_KEY_NOT_STARTED,
  COMPLETION_CARD_OPTION_KEY_STARTED,
  COMPLETION_CARD_OPTION_KEY_COMPLETE,
} from "%/dynamic-component-editor/constants/completion-card-option-keys";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import {
  COMPLETION_NOT_STARTED,
  COMPLETION_STARTED,
  COMPLETION_COMPLETE,
} from "%/dynamic-component-editor/stores/completion-status-store";

// Per-instance card override for a completion state (0 → base slot card). It's
class CompletionCardVariant extends BaseOption {
  // Compile is the identity: a cached value unlike the raw one is stale (DynamicOption ignores it).
  static compiledIsRaw = true;

  static defaultValue = 0;
}

export class CompletionCardVariantNotStarted extends CompletionCardVariant {
  // Own (not just inherited) default so the option-artifact generator —
  // which reads hasOwnProperty("defaultValue") — captures the key + PHP pair.
  static defaultValue = 0;

  // XXX: This option owns the whole "Components" group and renders all three
  // XXX: states itself. useCustomLabel + useVerticalOrientation is what
  // XXX: InspectorOptionToolV2 reads to give a tool the full row and suppress
  // XXX: the container's own header. The sibling options stay as the STORAGE
  // XXX: for the other two states but are hidden from the inspector, so three
  // XXX: separate groups collapse into one without changing any option key.
  static userInterfaceComponent = {
    useCustomLabel: true,
    useVerticalOrientation: true,
    label: "Components",
    component: inspectorTools.COMPLETION_COMPONENTS,
    props: {},
  };
}

export class CompletionCardVariantStarted extends CompletionCardVariant {
  static defaultValue = 0;

  static userInterfaceComponent = {
    label: "In progress card",
    component: inspectorTools.REFERENCED_COMPONENT_PICKER,
    props: {},
  };
}

export class CompletionCardVariantComplete extends CompletionCardVariant {
  static defaultValue = 0;

  static userInterfaceComponent = {
    label: "Complete card",
    component: inspectorTools.REFERENCED_COMPONENT_PICKER,
    props: {},
  };
}

export const COMPLETION_CARD_OPTION_BY_STATUS = {
  [COMPLETION_NOT_STARTED]: CompletionCardVariantNotStarted,
  [COMPLETION_STARTED]: CompletionCardVariantStarted,
  [COMPLETION_COMPLETE]: CompletionCardVariantComplete,
};

// XXX: The keys live in constants/completion-card-option-keys.js because the
// XXX: dependency walkers (JS helper + PHP) must share them and one of those is
// XXX: CJS. Re-exported here so option-side callers have one import, and pinned
// XXX: below so a class rename cannot silently desync the walkers.
export { COMPLETION_CARD_OPTION_KEYS };

export const COMPLETION_CARD_OPTION_KEY_BY_STATUS = {
  [COMPLETION_NOT_STARTED]: COMPLETION_CARD_OPTION_KEY_NOT_STARTED,
  [COMPLETION_STARTED]: COMPLETION_CARD_OPTION_KEY_STARTED,
  [COMPLETION_COMPLETE]: COMPLETION_CARD_OPTION_KEY_COMPLETE,
};

Object.entries(COMPLETION_CARD_OPTION_KEY_BY_STATUS).forEach(([status, expectedKey]) => {
  const derived = COMPLETION_CARD_OPTION_BY_STATUS[status].optionKey;
  if (derived !== expectedKey) {
    throw new Error(
      `completion card option key drift for "${status}": the option class derives `
      + `"${derived}" but constants/completion-card-option-keys.js declares `
      + `"${expectedKey}". The dependency walkers read the constant, so this would `
      + "silently drop the bound component from the compiled closure.",
    );
  }
});
